import React from "react";
import { Routes, Route } from "react-router-dom";
import { ErrorBoundary } from "./components/ErrorBoundary";
import KQuantSmartInsightsPage from "./pages/KQuantSmartInsightsPage/KQuantSmartInsightsPage";
import MyQuantFlowsPage from "./pages/MyQuantFlowsPage/MyQuantFlowsPage";

export default function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/" element={<KQuantSmartInsightsPage />} />
        <Route path="/my-quant-flows" element={<MyQuantFlowsPage />} />
      </Routes>
    </ErrorBoundary>
  );
}
